import { useBasicQueryControls } from '@app/shared/hooks/useBasicQueryControls.hook';

export const useFindProjectsQueryControls = () => {
  return useBasicQueryControls({
    initialValues: {
      search: '',
    },
  });
};
